import React from 'react';
import './ActualiteCard.css';


const formatDate = (dateStr) => {
  const [day, month, year] = dateStr.split('/'); 
  return `${day}/${month}/${year}`; 
};

const ActualiteCard = ({ title, description, photo, date }) => {
  const formattedDate = formatDate(date);

  return (
    <div className="actualite-card">
      <div className="actualite-header">
        <h3 className="actualite-title">{title}</h3>
        <p className="actualite-date">{formattedDate}</p>
      </div>
      <p className="actualite-description">{description}</p>
      {photo && <img className="actualite-photo" src={photo} alt="Actualité" />}
    </div>
  );
};

export default ActualiteCard;
